import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getId(id) {
    try {
      let response = await instance.get("/empresas/get/"+id);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getAll() {
    try {
      let response = await instance.get("/empresas/getAll");
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },

  async save(model) {
    try {
      let response = await instance.post("/empresas/save", model);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },
  
  async saveImage(model) {
    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      let response = await instance.post("/empresas/saveImage", model, config);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },

  async remove(item) {
    try {
      let response = await instance.delete("/empresas/"+item._id);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },
  
  async removeImage(item, empresa) {
    try {
      let response = await instance.delete("/empresas/removeImage/"+item._id+'/'+empresa);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/empresa.js